const resumeData = {
  name: "NIMA NAJAFLOU",
  contact: {
    email: "najaflounima@gmail.com",
    phone: "(469)254-5845",
    location: "Plano, TX 75023",
    linkedin: "https://linkedin.com/in/nimanajaflou",
  },
  summary:
    "Versatile and hands-on full-stack developer with a strong foundation in software engineering, IT operations, and technical leadership. Proven experience building web applications using modern JavaScript frameworks, developing secure backend services, and managing databases. Currently serving as a regional manager and Apple-certified technician, with a track record of optimizing operations, leading cross-functional teams, and delivering hardware repair solutions. Adept at bridging software and hardware domains to solve complex technical problems, with a growing focus on cybersecurity and secure development practices.",
  experience: [
    {
      period: "04/2023 - Present",
      company: "Mobile Kangaroo",
      location: "Dallas–Fort Worth, TX",
      title: "Regional Manager",
      responsibilities: [
        "Approved 1,500+ monthly repair orders across 35+ stores by auditing warranty and pricing, improving fulfillment speed.",
        "Maintained 95%+ part availability across 4 stores and cut overtime by 20% through scheduling.",
        "Recruited and trained 20+ technicians, standardizing onboarding and improving service consistency across locations.",
      ],
    },
    {
      period: "06/2021 - 04/2023",
      company: "Mobile Kangaroo",
      location: "Dallas–Fort Worth, TX",
      title: "Store Manager",
      responsibilities: [
        "Led store to $40K+ monthly revenue, becoming top sales location company-wide.",
        "Trained 30+ techs (incl. out-of-state) and boosted upsell revenue by 60%.",
        "Managed 10+ B2B accounts, ensuring timely high-volume service with 98%+ inventory accuracy.",
      ],
    },
    {
      period: "09/2020 - 06/2021",
      company: "Mobile Kangaroo",
      location: "Dallas–Fort Worth, TX",
      title: "Apple Certified Technician",
      responsibilities: [
        "Repaired 1,000+ Apple devices with a 95%+ first-time fix rate and reduced turnaround time by 25%.",
        "Performed 100+ secure data recoveries, improving trust and retention.",
        "Promoted to Store Manager in 9 months based on repair volume, upsells, and CSAT.",
      ],
    },
    {
      period: "07/2022 - 11/2023",
      company: "Springboard",
      location: "Remote",
      title: "Full-Stack Developer - Certificate Program",
      responsibilities: [
        "Built responsive UIs using HTML, CSS, React.js, jQuery, and Bootstrap.",
        "Created RESTful APIs with Node/Express and Flask, using JWTs and JSON schema validation.",
        "Worked with PostgreSQL via SQLAlchemy ORM and raw PG driver for CRUD and query logic.",
        "Built full-stack applications with authentication (JWT, OAuth2, Flask sessions) and secure data handling.",
        "Practiced TDD using Jest, React Testing Library, and documented with Markdown.",
      ],
    },
    {
      period: "02/2018 - 08/2019",
      company: "Digikala",
      location: "Tabriz, IRAN",
      title: "Software Engineer",
      responsibilities: [
        "Built and optimized RESTful APIs with Python, Flask, and PostgreSQL.",
        "Improved query performance by 40% through better indexing.",
        "Used AJAX and real-time data for personalized product recommendations.",
      ],
    },
  ],
  education: [
    {
      year: "2024",
      location: "Remote",
      degree: "Software Engineering Career Track",
      institution: "Springboard",
    },
    {
      year: "2019",
      location: "Tabriz, IRAN",
      degree: "Bachelor of Science in Computer Engineering – Software",
      institution: "Tabriz University",
    },
  ],
  skills: {
    frontend: "React.js, JavaScript, HTML, CSS, jQuery, Bootstrap",
    backend: "Node.js, Express.js, Flask, Python, Jinja",
    databases: "PostgreSQL, MongoDB, MySQL",
    tools: "Git, RESTful APIs, Postman, Fly.io, VS Code, GitHub",
    hardware:
      "Diagnostics, Hardware Repair, Device Imaging, Endpoint Support, Secure Data Handling",
    networks:
      "Network setup and troubleshooting, fundamental network configuration and diagnostics",
    security:
      "Warranty validation, data privacy practices, secure access control",
  },
  projects: [
    {
      name: "8bits Services",
      url: "https://8bits.services",
      tech: "MERN Stack",
    },
    {
      name: "Fix-Vault",
      url: "https://fix-vault.fly.dev",
      tech: "Flask, PostgreSQL, Jinja",
    },
    {
      name: "Phill – Smart Form Assistant",
      url: "https://nimanajaflou.com/phill", // URL not provided in resume
      tech: "JavaScript, Chrome Extension",
    },
  ],
  resumePdfPath: "./nima_najaflou_resume.pdf",
};

export default resumeData;
